<template>
  <div class="main_view">
    <el-container>
      <!--导航栏-->
      <el-header>
        <div class="yy_head">
          <div class="yy_head_left">
            <div class="yy_head_logo">
              <a href="/#/" target="_blank">
                <img src="/static/images/bigdata/maoyan_logo.png"/>
              </a>
            </div>
            <div class="yy_head_line"></div>
            <el-button plain icon="el-icon-document-copy" size="small" style="border-width: 0;" @click="head_tab(0)">需求管理</el-button>
            <el-button plain icon="el-icon-document-checked" size="small" style="border-width: 0; color:#409EFF;" @click="head_tab(1)">招募管理</el-button>
            <el-button plain icon="el-icon-user" size="small" style="border-width: 0;" @click="head_tab(2)">账户管理</el-button>
          </div>

          <div class="yy_head_right">
            <div class="yy_head_btn"><el-button plain size="small" icon="el-icon-document-checked">可邀约 {{userData.re_yy_count}} 次</el-button></div>
<!--            <div class="yy_head_btn"><el-button type="primary" icon="el-icon-success" size="small">已选 123 人</el-button></div>-->
            <div class="yy_head_user" @mouseover="logoutOver" @mouseout="logoutOut">
              <img class="yy_head_user_img" src="/static/images/bigdata/brand_head_icon.png"/>
              <div class="yy_head_user_nickname">{{userData.nickname}}</div>
              <div class="yy_head_user_logout" v-show="showLogin" @click="clickLogout">退 出 登 录</div>
            </div>
          </div>
        </div>
      </el-header>
      <!--内容栏-->
      <el-main>
        <!--招募列表栏-->
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       style="background-color: #FFFFFF; height: 40px; padding-left: 10px;
                       display: flex; align-items:center; margin-bottom: 10px; margin-top: 10px;">
          <el-breadcrumb-item :to="{ path: '/#/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>招募管理</el-breadcrumb-item>
        </el-breadcrumb>
        <el-table
          :data="datalist"
          border
          style="width: 100%;">
          <el-table-column
            fixed
            show-overflow-tooltip
            prop="request_campaign"
            label="需求标题"
            width="200">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="request_product"
            label="需求产品"
            width="200">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="platform"
            label="博主平台"
            width="80">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="url"
            label="博主链接"
            width="200">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            prop="fans"
            label="博主粉丝"
            width="80">
          </el-table-column>
          <el-table-column
            prop="category"
            label="博主类目"
            width="80">
          </el-table-column>
          <el-table-column
            prop="image_price"
            label="图文报价"
            width="100">
          </el-table-column>
          <el-table-column
            prop="video_price"
            label="视频报价"
            width="100">
          </el-table-column>
          <el-table-column
            prop="phone"
            label="手机号"
            width="120">
          </el-table-column>
          <el-table-column
            prop="wechat"
            label="微信号"
            width="120">
          </el-table-column>
          <el-table-column
            prop="create_date"
            label="创建日期"
            width="120">
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="110px">
            <template slot="header" slot-scope="scope">
              <el-button
                type="primary"
                icon="el-icon-edit"
                size="small" @click="requestSave()">导出</el-button>
            </template>
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                plain
                @click="requestEdit(scope.$index)">查看需求</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="pg_totalCount > pg_pageSize"
          @current-change="pg_pageIndexChange"
          @size-change="pg_pageSizeChange"
          :current-page="pg_pageIndex"
          :page-size=pg_pageSize
          layout="->, total, prev, pager, next, jumper"
          :total="pg_totalCount">
        </el-pagination>
      </el-main>
      <!--底部导航-->
      <el-footer v-if="pg_totalCount > pg_pageSize">
        <div class="yy_bottom">COPYRIGHT  2020-2024 杭州袤周云计算有限公司<a rel="nofollow" href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2022031665号</a></div>
      </el-footer>
    </el-container>
  </div>
</template>


<script>
import moment from "moment";
import { Base64 } from 'js-base64';
import process from "shelljs";
export default {
  name: "YYZhaomuList",
  data() {
    return {
      userData: '',
      showLogin: false,
      pg_pageIndex: 1,
      pg_pageSize: 20,
      pg_totalCount: 0,
      datalist: [],
    }
  },
  methods: {
    clickLogout () {
      // 本地保存token
      this.$cookies.remove("UserToken");
      this.$cookies.remove("UserName");
      // 跳转
      this.$router.push('/yylogin');
    },
    logoutOver () {
      this.showLogin = true;
    },
    logoutOut () {
      this.showLogin = false;
    },
    head_tab(val) {
      if(val===0){
        this.$router.push({path: '/yyrequests'});
      }
      // if(val===1){
      //   this.$router.push({path: '/yyzhaomus'});
      // }
      if(val===2){
        this.$router.push({path: '/yyaccounts'});
      }
    },
    requestSave() {
      this.getExcelData();
    },
    requestEdit(index) {
      console.log(`index: ${index}`);
      let request_id = this.datalist[index].request_pk;
      console.log(`request_id: ${request_id}`);
      this.$router.push({path: '/yyrequest_edit', query: {request_id: request_id}});
    },
    pg_pageSizeChange(val) {
      console.log(`页数: ${val}`);
      this.pg_pageSize = val;
      this.getListData();
    },
    pg_pageIndexChange(val) {
      console.log(`页码: ${val}`);
      this.pg_pageIndex = val;
      this.getListData();
    },
    getExcelData() {
      let sendTime = moment(new Date()).format("YYYYMMDDHHssmm");
      let sign = Base64.encode('Maozhou2024' + sendTime);
      let base = '/api';
      if (process.env.NODE_ENV === "development") {
        base = 'http://api.wushangxianzhi.com';
      }
      let url = '/api/v2/maoyy/maoyaoyue_zhaomu_excel';
      this.$axios.defaults.headers.common['Authorization'] = this.$cookies.get('UserToken')
      this.$axios({
        method: 'post',
        url: `${base}${url}`,
        responseType: 'blob',
        contentType: 'application/json',
        data: JSON.stringify({
          'sign': sign,
        })
      }).then((res) => {
        console.log("success:", res);
        // 创建一个包含Excel文件的Blob对象
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        // 创建一个下载链接并设置链接属性
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '达人列表.xlsx');
        // 点击链接进行下载
        document.body.appendChild(link);
        link.click();
        // 清除链接对象
        document.body.removeChild(link);
      }).catch((res) => {
        console.log("error:", res);
        this.$message({
          showClose: true,
          offset: 100,
          message: res,
          type: 'error'
        });
      })
    },
    getListData() {
      let sendTime = moment(new Date()).format("YYYYMMDDHHssmm");
      let sign = Base64.encode('Maozhou2024' + sendTime);
      let base = '/api';
      if (process.env.NODE_ENV === "development") {
        base = 'http://api.wushangxianzhi.com';
      }
      let url = '/api/v2/maoyy/maoyaoyue_zhaomu_list';
      this.$axios.defaults.headers.common['Authorization'] = this.$cookies.get('UserToken')
      this.$axios({
        method: 'post',
        url: `${base}${url}`,
        responseType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          'sign': sign,
          'page_index': this.pg_pageIndex,
          'page_size': this.pg_pageSize,
        })
      }).then((res) => {
        console.log("success:", res);
        let data = res.data;
        if (data.error === 0) {
          this.pg_totalCount = data.total_count;
          this.datalist = data.result;
          console.dir(this.pg_totalCount);
        } else {
          this.$message({
            showClose: true,
            offset: 100,
            message: data.message,
            type: 'error'
          });
        }
      }).catch((res) => {
        console.log("error:", res);
        this.$message({
          showClose: true,
          offset: 100,
          message: res,
          type: 'error'
        });
      })
    },
    getUserData() {
      let sendTime = moment(new Date()).format("YYYYMMDDHHssmm");
      let sign = Base64.encode('Maozhou2024' + sendTime);
      let base = '/api';
      if (process.env.NODE_ENV === "development") {
        base = 'http://api.wushangxianzhi.com';
      }
      let url = '/api/v2/maoyy/yy_user_detail';
      this.$axios.defaults.headers.common['Authorization'] = this.$cookies.get('UserToken')
      this.$axios({
        method: 'post',
        url: `${base}${url}`,
        responseType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          'sign': sign,
        })
      }).then((res) => {
        console.log("success:", res);
        let data = res.data;
        if (data.error === 0) {
          this.userData = data.result[0];
        } else {
          this.$message({
            showClose: true,
            offset: 100,
            message: data.message,
            type: 'error'
          });
        }
      }).catch((res) => {
        console.log("error:", res);
        this.$message({
          showClose: true,
          offset: 100,
          message: res,
          type: 'error'
        });
      })
    }
  },
  mounted () {
    if (this.$cookies.get('UserToken')) {
      // 加载数据
      this.getListData();
      this.getUserData();
    } else {
      // 退出登录
      this.clickLogout ();
    }
  },
  metaInfo: {
    title: "袤周-AI智能找“人”工具",
    meta: [
      { name: "viewport", content: "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0" },
      { name: "keywords", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "description", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "format-detection", content: "telephone=no,email=no" }
    ],
    link: [{
      rel: 'shortcut icon',
      href: '/static/favicon.ico'
    }]
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '../comm/css/base.styl'
.main_view
  width 100%
  background-color #f5f7fc
  min-height 1500px
  .el-header
    padding 0
    top 0
    position sticky
    z-index 10
    background-color $white
    .yy_head
      background-color $white
      box-shadow 0 1px 8px 0 rgba(0,0,0,0.1)
      width 100%
      display flex
      .yy_head_left
        padding-left 12%
        display flex
        flex-direction row
        .yy_head_logo
          height 60px
          img
            height 50px
            padding-top 5px
        .yy_head_line
          margin-left 10px
          width 1px
          height 60px
          background-color $colorE

      .yy_head_right
        height 60px
        width auto
        margin-left auto
        padding-right 12%
        display flex
        flex-direction row
        .yy_head_btn
          display flex
          align-items center
          margin-right 10px
        .yy_head_user
          display flex
          flex-direction row
          height 60px
          .yy_head_user_img
            margin-top 10px
            margin-left 10px
            height 40px
            width 40px
            border-radius 60px
          .yy_head_user_nickname
            color #000000
            font-size 14px
            margin-left 10px
            display flex
            align-items center
          .yy_head_user_logout
            margin-right 12%
            position absolute
            width 120px
            height 38px
            display flex
            flex-direction column
            align-items center
            justify-content center
            color $white
            cursor pointer
            z-index 1
            right 0
            top 60px
            font-size 14px
            background $grey


  .el-container
    padding 0

  .el-main
    padding 0
    padding-left 12%
    padding-right 12%

  .el-footer
    padding 0
    margin-top 20px
    bottom 0
    left 0
    width 100%
    .yy_bottom
      background linear-gradient(135deg, rgba(51,51,51,1) 0%, rgba(17,17,17,1) 100%)
      height auto
      display flex
      flex-direction row
      color $white
      justify-content center
      align-items center
      a
        margin-left: 10px
        margin-top 20px
        margin-bottom 20px
        color $white
</style>




// WEBPACK FOOTER //
// src/components/yaoyue/YYZhaomuList.vue